<script>
import { mapGetters } from 'vuex';
import { useAdmin } from 'dashboard/composables/useAdmin';
import { useAccount } from 'dashboard/composables/useAccount';
import Banner from 'dashboard/components/ui/Banner.vue';

const EMPTY_SUBSCRIPTION_INFO = {
  status: null,
  endsOn: null,
  trial: null,
  trialDays: null,
  planName: null,
};

export default {
  components: { Banner },
  setup() {
    const { isAdmin } = useAdmin();

    const { accountId } = useAccount();

    return {
      accountId,
      isAdmin,
    };
  },
  computed: {
    ...mapGetters({
      isOnChatwootCloud: 'globalConfig/isOnChatwootCloud',
      getAccount: 'accounts/getAccount',
    }),
    bannerMessage() {
      const { daysLeft, isExpired, isTrial } = this.getSubscriptionInfo();

      if (isExpired) {
        return '⚠️ 订阅已过期，请及时续费以继续使用服务';
      }

      if (daysLeft <= 3) {
        return `⚠️ 订阅即将在 ${daysLeft} 天后过期，请及时续费`;
      }

      if (daysLeft <= 7) {
        return `ℹ️ 订阅将在 ${daysLeft} 天后过期`;
      }

      const trialText = isTrial ? '试用' : '';
      return `✅ ${trialText}订阅有效期至 ${this.formatDate(this.getSubscriptionInfo().endsOn)}，剩余 ${daysLeft} 天`;
    },
    actionButtonMessage() {
      const { isExpired } = this.getSubscriptionInfo();
      return isExpired ? '立即续费' : '管理订阅';
    },
    colorScheme() {
      const { daysLeft, isExpired } = this.getSubscriptionInfo();

      if (isExpired || daysLeft <= 3) {
        return 'alert';
      }

      if (daysLeft <= 7) {
        return 'warning';
      }

      return 'secondary';
    },
    shouldShowBanner() {
      // 始终显示订阅信息（只要有订阅数据）
      const { status } = this.getSubscriptionInfo();
      return !!status;
    },
  },
  methods: {
    routeToBilling() {
      // 使用路由跳转到套餐详情页面
      this.$router.push({
        path: `/app/accounts/${this.accountId}/subscription/plan`,
      });
    },
    getSubscriptionInfo() {
      const account = this.getAccount(this.accountId);
      if (!account) return EMPTY_SUBSCRIPTION_INFO;

      const subscription = account.custom_attributes;
      if (!subscription) return EMPTY_SUBSCRIPTION_INFO;

      const {
        subscription_status: status,
        subscription_ends_on: endsOn,
        trial: isTrial,
        trial_days: trialDays,
        plan_name: planName,
      } = subscription;

      const endDate = new Date(endsOn);
      const now = new Date();
      const daysLeft = Math.ceil((endDate - now) / (1000 * 60 * 60 * 24));
      const isExpired = daysLeft < 0;

      return {
        status,
        endsOn: endDate,
        isTrial,
        trialDays,
        planName,
        daysLeft: isExpired ? 0 : daysLeft,
        isExpired,
      };
    },
    formatDate(date) {
      if (!date) return '-';
      return date.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <Banner
    v-if="shouldShowBanner"
    :color-scheme="colorScheme"
    :banner-message="bannerMessage"
    :action-button-label="actionButtonMessage"
    has-action-button
    @primary-action="routeToBilling"
  />
</template>
